import { useAppSelector } from '@/store/hooks';
import ClientContainer from '@/services/client/ClientContainer';

function DirectPaymentClientContainer({ children }: React.PropsWithChildren) {
  const client = useAppSelector(state => state.directPayment.client) ?? null;

  return (
    <ClientContainer clientOverride={client}>
      {children}
    </ClientContainer>
  );
}

export default DirectPaymentClientContainer;
